import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Typography,
  Paper,
  CircularProgress,
  Autocomplete,
  TextField,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Tooltip,
  TableRow,
  alpha,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchUserList,
  fetchPermission,
  createPermission,
} from "../../../Services/Services";

const sidebarMenu = [
  {
    group: "Settings",
    items: [
      { label: "Assign" },
      { label: "Profiles" },
      // { label: "Division" },
      { label: "Creditor" },
      { label: "Bank Accounts" },
      { label: "Debitor" },
      { label: "Phase" },
       { label: "Department" },
      { label: "BOM Creation" },
      { label: "BOM Creation List" },
      { label: "Voltage Ratio" },
      { label: "Rating Specification" },
      { label: "Winding Material" },
      // { label: "Expense" },
      // { label: "Imprest A/C" },
      // { label: "Adv worker" },
      // { label: "Transporters" },
    ],
  },
  // {
  //   group: "Administrator",
  //   items: [
  //     { label: "Purchase Order" },
  //     { label: "Sale Order" },
  //     { label: "Indent list" },
  //     { label: "Performa Invoice" },
  //     { label: "Journal Voucher" },
  //     { label: "Purchase Voucher" },
  //     { label: "Payment Voucher" },
  //     { label: "Sales Voucher" },
  //     { label: "Receipt Voucher" },
  //     { label: "Contra Voucher" },
  //   ],
  // },
  {
    group: "Store",
    items: [
      // { label: "Store Dashboard" },
      // { label: "Category" },
      // { label: "Sub Category" },
      // { label: "Unit" },
      { label: "Product Type" },
      // { label: "Stock Items" },
      // { label: "Indent" },
      // { label: "Purchase Order" },
      // { label: "Purchase Voucher" },
      // { label: "Purchase Entry" },
      // { label: "Issue Note" },
      // { label: "Purchase List" },
      // { label: "Purchase Entry Against PO" },
      // { label: "Direct Purchase Entry" },
      // { label: "Transfer" },
      // { label: "MTC" },

       { label: "Category" },
      { label: "Unit" },
      // { label: "Size" },
      { label: "Stock Items" },
      { label: "Purchase Order" },
      { label: "Purchase List" },
      { label: "PE WithIndent" },
      { label: "PE WithoutIndent" },
      { label: "Issue Note" },
    ],
  },
  {
    group: "Accounts",
    items: [
      { label: "Accounts Dashboard" },
      { label: "Order Inward" },
      { label: "Sale Order" },
      { label: "Proforma Invoice" },
      // { label: "Journal Voucher" },
      // { label: "Contra Voucher" },
      // { label: "Sales Voucher" },
      // { label: "Payments" },
      // { label: "Receipt" },
    ],
  },
  // {
  //   group: "Operational Department",
  //   items: [{ label: "Design & Drawing" }, { label: "IBR Formalities" }, { label: "Issue MTC" }],
  // },
  {
    group: "Sales & Marketing",
    items: [
      { label: "Enquiry" },
      { label: "Quotation" },
      { label: "Feedback" },
    ],
  },
  // {
  //   group: "Reports",
  //   items: [
  //     { label: "Project Summary" },
  //     { label: "Cash Ledger" },
  //     { label: "Bank Ledger" },
  //     { label: "Ledger Book" },
  //     { label: "Journal Vch. Report" },
  //     { label: "Sale Order" },
  //     { label: "Daily Payment" },
  //     { label: "Proforma Invoice" },
  //   ],
  // },
  {
    group: "Stock Reports",
    items: [
      { label: "Project Summary" },
      { label: "Stock Summary" },
      { label: "Stock Ladger" },
      { label: "Reserve Stock Ladger" },
      { label: "Material Inward" },
      { label: "Material Issue" },
      // { label: "Division wise material Issue Note" },
      { label: "Value of Closing Stock" },
      { label: "Item Wise Consumption" },
      { label: "Pending GRN" },
      { label: "Fast and slow moving items" },
      // { label: "Indent Status" },
      { label: "PO Status" },
      // { label: "PO Indent" },
      { label: "Purchase Voucher PO" },
    ],
  },
];

const AssignPagesToUser = () => {
  const [users, setUsers] = useState([]);
  const [pages, setPages] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedPages, setSelectedPages] = useState([]); // Now stores {group, label} objects
  const [loading, setLoading] = useState(true);
  const isAdmin = localStorage.getItem("role") != "Staff";

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetchUserList();

        setUsers(Array.isArray(res) ? res : []);
      } catch (err) {
        toast.error("Failed to load users");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();


    // Generate pages with unique IDs based on group + label
    let idCounter = 100;
    const generatedPages = sidebarMenu.flatMap((section) =>
      section.items.map((item) => ({
        id: `${section.group}_${item.label}_${++idCounter}`, // Unique ID
        label: item.label,
        group: section.group,
      }))
    );

    setPages(generatedPages);
  }, []);

  useEffect(() => {
    const loadPermissions = async () => {
      if (!selectedUser) {
        setSelectedPages([]);
        return;
      }

      try {
        const resp = await fetchPermission(selectedUser);
        const data = Array.isArray(resp) ? resp : [];

        // Convert API response to selected page IDs
        const matchedIds = pages
          .filter((page) =>
            data.some((perm) => perm.group === page.group && perm.label === page.label)
          )
          .map((p) => p.id);

        setSelectedPages(matchedIds);

        if (!isAdmin) {
          const localKey = `user_permissions_${selectedUser}`;
          localStorage.setItem(localKey, JSON.stringify(data));
        }
      } catch (err) {
        console.error("Failed to load permissions:", err);
        setSelectedPages([]);
      }
    };

    if (pages.length > 0) {
      loadPermissions();
    }
  }, [selectedUser, pages, isAdmin]);

  const handleCheckboxChange = (pageId) => {
    setSelectedPages((prev) =>
      prev.includes(pageId)
        ? prev.filter((id) => id !== pageId)
        : [...prev, pageId]
    );
  };

  const handleSubmit = async () => {
    if (!selectedUser) {
      toast.error("Please select a user first.");
      return;
    }

    if (selectedPages.length === 0) {
      toast.error("Please tick at least one checkbox.");
      return;
    }

    try {
      // Convert selected page IDs to {group, label} objects
      const selectedPermissions = pages
        .filter((p) => selectedPages.includes(p.id))
        .map((page) => ({
          group: page.group?.trim() || "",
          label: page.label?.trim() || "",
        }))


      const payload = {
        user_id: selectedUser,
        permissions: selectedPermissions, // ✅ Changed from 'pages' to 'permissions'
      };

      await createPermission(payload);
      toast.success("Permissions saved successfully!");
    } catch (err) {
      console.error("Save error:", err);
      toast.error("Failed to save permissions");
    }
  };

  // Master checkbox: check/uncheck all
  const allPageIds = pages.map((p) => p.id);
  const allSelected =
    allPageIds.length > 0 &&
    allPageIds.every((id) => selectedPages.includes(id));
  const partiallySelected =
    !allSelected && allPageIds.some((id) => selectedPages.includes(id));

  return (
    // <Box sx={{ px: 0, pt: 0, mt: -3, maxWidth: 1200, mx: "auto" }}>
    <Box sx={{ mt: { xs: 4, md: 0 }, px: { xs: 1, sm: 0 } }}>
      <Paper sx={{ mb: 2, bgcolor: "background.paper" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              flexWrap: "wrap",
              mb: 1,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* Top Section */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
                mb: 3,
              }}
            >
              <Autocomplete
                options={Array.isArray(users) ? users : []}
                getOptionLabel={(user) =>
                  user.department_name
                    ? `${user.name} (${user.department_name})`
                    : user.name || ""
                }
                value={
                  (Array.isArray(users) ? users : []).find(
                    (u) => u.id === selectedUser
                  ) || null
                }
                onChange={(e, newValue) => setSelectedUser(newValue?.id || "")}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography sx={{ fontSize: "0.85rem", fontWeight: 600 }}>
                        {option.name}
                      </Typography>
                      <Typography sx={{ fontSize: "0.7rem", color: "text.secondary" }}>
                        {option.department_name || "No Department"} • {option.email}
                      </Typography>
                    </Box>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search User"
                    variant="outlined"
                    fullWidth
                    sx={{
                      mr: 2,
                      minWidth: 250,
                      "& .MuiInputBase-root": {
                        height: 35,
                        borderRadius: 0,
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.7rem",
                        top: "-5px",
                      },
                    }}
                  />
                )}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={allSelected}
                    indeterminate={partiallySelected}
                    disabled={!selectedUser}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedPages(allPageIds);
                      } else {
                        setSelectedPages([]);
                      }
                    }}
                  />
                }
                label={<Typography variant="body2">All Assign</Typography>}
              />
              <Button
                variant="contained"
                size="small"
                onClick={handleSubmit}
                disabled={!selectedUser}
                sx={{
                  height: 35,
                  minWidth: 120,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "0.7rem",
                  px: 2,
                  borderRadius: "0",
                }}
              >
                Save Permissions
              </Button>
            </Box>

            {/* Table Section */}
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {sidebarMenu.map((group) => {
                      const groupPageIds = pages
                        .filter((p) => p.group === group.group)
                        .map((p) => p.id);

                      const groupAllSelected = groupPageIds.every((id) =>
                        selectedPages.includes(id)
                      );
                      const groupPartial =
                        !groupAllSelected &&
                        groupPageIds.some((id) => selectedPages.includes(id));

                      return (
                        <TableCell
                          key={group.group}
                          sx={{
                            fontWeight: "normal",
                            fontSize: "0.85rem",
                            bgcolor: (t) =>
                              t.palette.mode === "dark"
                                ? alpha(t.palette.common.white, 0.06)
                                : "#f5f5f5",
                            color: "text.primary",
                            px: 0.5,
                            py: 0.25,
                            width: "200px",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                checked={groupAllSelected}
                                indeterminate={groupPartial}
                                disabled={!selectedUser}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedPages((prev) => [
                                      ...new Set([...prev, ...groupPageIds]),
                                    ]);
                                  } else {
                                    setSelectedPages((prev) =>
                                      prev.filter(
                                        (id) => !groupPageIds.includes(id)
                                      )
                                    );
                                  }
                                }}
                              />
                            }
                            label={
                              <Typography
                                variant="body2"
                                sx={{ color: "text.primary", fontSize: "0.85rem" }}
                                align="center"
                              >
                                {group.group}
                              </Typography>
                            }
                          />
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Array.from({
                    length: Math.max(...sidebarMenu.map((g) => g.items.length)),
                  }).map((_, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      sx={{
                        bgcolor: (t) =>
                          rowIndex % 2 === 0
                            ? "background.paper"
                            : t.palette.mode === "dark"
                              ? alpha(t.palette.common.white, 0.04)
                              : "#f9f9f9",
                        "&:hover": {
                          bgcolor: "action.hover",
                        },
                      }}
                    >
                      {sidebarMenu.map((group) => {
                        const item = group.items[rowIndex];
                        const page = pages.find(
                          (p) =>
                            p.label?.trim() === item?.label?.trim() &&
                            p.group?.trim() === group.group?.trim()
                        );

                        return (
                          <TableCell
                            key={group.group + rowIndex}
                            align="left"
                            sx={{ px: 0.5, py: 0.25, maxWidth: 160 }}
                          >
                            {item ? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={selectedPages.includes(page?.id)}
                                    disabled={!selectedUser}
                                    onChange={() =>
                                      handleCheckboxChange(page?.id)
                                    }
                                  />
                                }
                                label={
                                  <Tooltip title={item.label}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: 140,
                                        fontSize: "0.85rem",
                                      }}
                                    >
                                      {item.label}
                                    </Typography>
                                  </Tooltip>
                                }
                              />
                            ) : null}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </Paper>
      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default AssignPagesToUser;